const routMain = (id = ":id") => `/newsDitail/${id}`;

export default routMain;